import http from "../core/http";
const group = 'reports';

export const getDataListRequest = async (data) => {
    return await http.post(`${group}/bags`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getAirlinesListRequest = async (data) => {
    return await http.post(`${group}/getAirlines`, data).then(res => res.data).catch(http.defaultCatch);
}

export const exportDataRequest = async (data) => {
    return await http({ url: `${group}/bagsExport`, method: "POST", data: data, responseType: "blob" }).then(res => res.data).catch(http.defaultCatch);
}
